import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {externalMailingListView_template} from "../components/templates/externalMailingListView_template";

declare var ko: any;
declare var page: any;

export class external_mailing_list_view extends vnModule_knockoutJS {

    protected externalMailingListView: externalMailingListView_template;
    protected XHRHdl: XMLHttpRequestHandler;

    buildContent(): Array<Element> {
        this.externalMailingListView = new externalMailingListView_template("externalMailingListView", this.viewModel, this);
        return [this.externalMailingListView.build()];
    }

    protected getModuleName(): string {
        return "external_mailing_list_view";
    }

    fillPage() {
        this.getMailingListDataForView()
    }

    private getMailingListDataForView() {

        this.loadingIn(this.externalMailingListView.builtTemplate);

        let url : string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/external-mailingList/get/view/' + this.getVnAppZone().app.params.id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetMailingListDataForView;
        this.XHRHdl.execute();
    }

    private onGetMailingListDataForView(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                let mailingList = responseParsed.data
                obj.externalMailingListView.setMailingListData(mailingList);
            });

            obj.loadingOut(obj.externalMailingListView.builtTemplate);
        }
    }

    protected onClickEditMailingList(id){
        let brandId = this.getVnAppZone().app.params.idBrand
        page("/brand/" + brandId + "/newsletter/external-mailing-lists/edit/" + id + '/')
    }

    protected onClickCancel(){
        let brandId = this.getVnAppZone().app.params.idBrand
        page.redirect("/brand/" + brandId + "/newsletter/external-mailing-lists/")
    }
}


// WEBPACK FOOTER //
// ./js/modules/external_mailing_list_view.ts